/* LunaLuz — Vidéos (remplace ReelUp). Sans dépendance. */
(function () {
  'use strict';
  if (window.__llzVideosInit) return;
  window.__llzVideosInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var canHls = document.createElement('video').canPlayType('application/vnd.apple.mpegurl') !== '';

  function load(video) {
    if (video.dataset.loaded) return;
    var src = video.dataset.src || video.dataset.full;
    if (!src) return;
    video.src = src;
    video.preload = 'metadata';
    video.dataset.loaded = '1';
  }

  function safePlay(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init(root) {
    if (root.dataset.llzReady) return;
    root.dataset.llzReady = '1';
    var autoplay = root.dataset.autoplay === 'true' && !reduceMotion && !saveData;
    var track = root.querySelector('[data-llz-track]');
    var videos = Array.prototype.slice.call(root.querySelectorAll('.llz-videos__video'));
    var prev = root.querySelector('[data-llz-prev]');
    var next = root.querySelector('[data-llz-next]');

    /* 1. Chargement paresseux : la source n'est posée qu'à l'approche de l'écran */
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { load(e.target); near.unobserve(e.target); }
        });
      }, { rootMargin: '300px 400px' });
      /* 2. Lecture muette en boucle quand au moins 60 % visible, pause sinon */
      var vis = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.6 && autoplay && !root.__dialogOpen) {
            load(v); safePlay(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6] });
      videos.forEach(function (v) { near.observe(v); vis.observe(v); });
    } else {
      videos.forEach(load);
    }

    /* 3. Flèches desktop */
    function updateNav() {
      if (!track || !prev || !next) return;
      var overflow = track.scrollWidth > track.clientWidth + 4;
      prev.hidden = !overflow || track.scrollLeft <= 4;
      next.hidden = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function scrollByPage(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (track) {
      track.addEventListener('scroll', function () { window.requestAnimationFrame(updateNav); }, { passive: true });
      window.addEventListener('resize', updateNav);
      if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
      if (next) next.addEventListener('click', function () { scrollByPage(1); });
      updateNav();
    }

    /* 4. Lecteur plein écran avec son */
    var dialog = root.querySelector('[data-llz-dialog]');
    var full = root.querySelector('[data-llz-full]');
    var dProduct = root.querySelector('[data-llz-dialog-product]');
    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-llz-open]'));
    var current = 0;
    var lastFocus = null;

    function show(i) {
      if (!openers.length) return;
      current = (i + openers.length) % openers.length;
      var btn = openers[current];
      var src = btn.querySelector('video');
      var url = src.dataset.full || src.dataset.src || (canHls && src.dataset.hls); /* mp4 720p d abord : HLS natif Chrome instable (15/10) */
      full.poster = src.getAttribute('poster') || '';
      full.src = url;
      full.muted = false;
      full.setAttribute('aria-label', btn.getAttribute('aria-label') || 'Vidéo');
      var card = btn.parentNode.querySelector('[data-llz-product]');
      dProduct.innerHTML = '';
      if (card) {
        var clone = card.cloneNode(true);
        clone.removeAttribute('data-llz-product');
        dProduct.appendChild(clone);
        bindAtc(dProduct);
      }
      safePlay(full);
    }
    function open(i) {
      lastFocus = document.activeElement;
      root.__dialogOpen = true;
      videos.forEach(function (v) { v.pause(); });
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      show(i);
      var closeBtn = dialog.querySelector('[data-llz-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      full.pause();
      full.removeAttribute('src');
      full.load();
      if (dialog.open && typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    }
    if (dialog && full) {
      openers.forEach(function (btn) {
        btn.addEventListener('click', function () { open(openers.indexOf(btn)); });
      });
      dialog.addEventListener('close', function () {
        root.__dialogOpen = false;
        document.documentElement.style.overflow = '';
        full.pause();
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      });
      dialog.querySelector('[data-llz-close]').addEventListener('click', close);
      Array.prototype.forEach.call(dialog.querySelectorAll('[data-llz-step]'), function (b) {
        b.addEventListener('click', function () { show(current + parseInt(b.dataset.llzStep, 10)); });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      });
      /* balayage horizontal sur mobile */
      var x0 = null;
      dialog.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      dialog.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 60) show(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
      full.addEventListener('ended', function () { if (openers.length > 1) show(current + 1); });
    }

    /* 5. Ajout panier sans quitter la page (repli : soumission classique du formulaire) */
    function bindAtc(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-llz-atc]'), function (form) {
        if (form.__llz) return;
        form.__llz = true;
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var btn = form.querySelector('button');
          var label = btn.textContent;
          btn.setAttribute('aria-busy', 'true');
          var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root_ + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }], sections: 'cart-icon-bubble' })
          }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (data) {
            btn.textContent = 'Ajouté ✓';
            var html = data.sections && data.sections['cart-icon-bubble'];
            var bubble = document.getElementById('cart-icon-bubble');
            if (html && bubble) {
              var tmp = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
              if (tmp) bubble.innerHTML = tmp.innerHTML;
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }).catch(function () {
            form.submit();
          }).finally(function () {
            btn.removeAttribute('aria-busy');
            setTimeout(function () { btn.textContent = label; }, 2200);
          });
        });
      });
    }
    bindAtc(root);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-llz-videos]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-llz-videos]');
    if (el) init(el);
  });
})();
